import { BusinessHoursBuilder, RuleConditionType, RuleOperator, RuleConditionBuilder } from '..';
import { SLATimezoneType, SLATrigger } from './new-sla-policy-settings.i';
import { TicketPriority } from '../../tickets';
var defaultAssignCondition = {
    type: RuleConditionType.TICKET_ASSIGNED,
    operator: RuleOperator.IS,
    assignedUserIds: [],
    assignedGroupIds: []
};
var SlaPolicyBuilder = /** @class */ (function () {
    function SlaPolicyBuilder() {
        var _a;
        this.slaPolicy = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'Bob Saget',
            enabled: true,
            connectedRules: [],
            policySettings: {
                resetResolutionTimeAfterSolve: false,
                useFirstReplyTargetAfterSolve: false,
                breachRules: [],
                businessHours: new BusinessHoursBuilder().build(),
                applyPolicySettings: {
                    triggers: [SLATrigger.TICKET_CREATED],
                    ticketAssignedConditions: {
                        ticketAssignedCondition: new RuleConditionBuilder().withType(RuleConditionType.TICKET_ASSIGNED).withData([]).build(),
                        useAdditionalConditions: false,
                        additionalConditions: {
                            mustConditions: [],
                            shouldConditions: []
                        }
                    },
                    ticketCreatedConditions: {
                        mustConditions: [defaultAssignCondition],
                        shouldConditions: []
                    }
                },
                targets: (_a = {},
                    _a[TicketPriority.HIGH] = {
                        resolutionMinutes: 10,
                        firstReplyMinutes: 20,
                        nextReplyMinutes: 30
                    },
                    _a),
                slaTimezoneType: SLATimezoneType.TENANT,
                ticketPrioritySchedulesIds: {},
            },
            userId: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
        };
    }
    SlaPolicyBuilder.prototype.withId = function (id) {
        this.slaPolicy.id = id;
        return this;
    };
    SlaPolicyBuilder.prototype.withName = function (name) {
        this.slaPolicy.name = name;
        return this;
    };
    SlaPolicyBuilder.prototype.withEnabled = function (enabled) {
        this.slaPolicy.enabled = enabled;
        return this;
    };
    SlaPolicyBuilder.prototype.withConnectedRules = function (connectedRules) {
        this.slaPolicy.connectedRules = connectedRules;
        return this;
    };
    SlaPolicyBuilder.prototype.withPolicySettings = function (policySettings) {
        this.slaPolicy.policySettings = policySettings;
        return this;
    };
    SlaPolicyBuilder.prototype.build = function () {
        return this.slaPolicy;
    };
    return SlaPolicyBuilder;
}());
export { SlaPolicyBuilder };
//# sourceMappingURL=sla-policy.builder.js.map